import { render, staticRenderFns } from "./cover-upload.vue?vue&type=template&id=5a82cb12&scoped=true&"
import script from "./cover-upload.vue?vue&type=script&lang=js&"
export * from "./cover-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a82cb12",
  null
  
)

export default component.exports